module.exports = __webpack_public_path__ + "img/olivia.4b9ab132.png";